import { createFileRoute } from "@tanstack/react-router"

import { UnterlagenPage } from "@/components/unterlagen-page"

export const Route = createFileRoute("/_app/unterlagen")({
  component: UnterlagenPage,
})
